import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box'
import GooglePayOption from './Gpay';

interface PaymentOptionsProps {
	selectedPaymentMode: string;
	onSetSelectedPaymentMode: (mode: string) => void;
}

export default function PaymentOptions(props: PaymentOptionsProps) {

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		props.onSetSelectedPaymentMode((event.target as HTMLInputElement).value);
	};

	return (
		<Box display="flex" flexDirection="column" justifyContent="center">
			<FormControl sx={{ mt: 2 }}>
				<RadioGroup
					name="payment-option"
					value={props.selectedPaymentMode}
					onChange={handleChange}
				>
					<FormControlLabel value="gpay" sx={{ mb: 1 }} control={<GooglePayOption />} label="" />
					<FormControlLabel value="cod" control={<Radio />} label="Cash on delivery" />
				</RadioGroup>
			</FormControl>
		</Box>
	);
}
